<template>
  <v-container
    id="about"
    tag="section"
  >
    <base-subheading>Об организации</base-subheading>
    <p>
      <strong>{{about.recipient_full}}</strong><br>
      {{about.recipient_info}}
    </p>
    <p>
      Вы можете сделать их жизнь лучше!
      <v-btn
        color="primary"
        depressed
        round
        href="/childrens.html"
      >
        Кого?
      </v-btn>
      <v-btn
        color="primary"
        depressed
        round
        href="/help.html"
      >
        Как?
      </v-btn>
</p>
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        about: {}
      }
    },
    mounted () {
      axios.get('/static/data/about.json')
        .then(response => {
          this.about = response.data
        }).catch(error => {
          console.log(error)
        })
    }
  }
</script>
